import React from "react";
import { StylesConfig } from "react-select";
import { COLUMNS_KEYWORDS } from "../../modules/search/consts";
import { MenuItem } from "../@types";
import { GridItemConfig } from "./GridConfig";
import TooltipIcon from "../TooltipIcon";

export const styles: StylesConfig<MenuItem, false> = {
  control: base => ({
    ...base,
    borderRadius: "0",
    minHeight: "24px",
    ":hover": {
      cursor: "pointer",
      color: "black"
    }
  }),
  dropdownIndicator: base => ({
    ...base,
    padding: "2px 4px",
    ":hover": {
      cursor: "pointer",
      color: "black"
    }
  }),
  indicatorsContainer: base => ({
    ...base,
    padding: "2px",
    ":hover": {
      cursor: "pointer",
      color: "black"
    }
  }),
  menuList: base => ({
    ...base,
    background: "#e3e3e3"
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#d2d2d2" : "#e3e3e3",
    color: "black",
    cursor: "pointer",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    ":hover": {
      backgroundColor: "#d2d2d2"
    }
  }),
  valueContainer: base => ({
    ...base,
    width: "110px"
  }),
  menuPortal: base => ({
    ...base,
    zIndex: 9999
  })
};

export const MENU_ITEMS: Record<string, GridItemConfig> = {
  EXACT_DATE: {
    label: "Display Exact Dates",
    value: "exact_date",
    setting: "table"
  },
  SHOW_SUBMISSION_TIME: {
    label: "Show Last Submitted",
    value: COLUMNS_KEYWORDS.SUBMISSION_TIME,
    setting: "column",
    disabled: false
  },
  SHOW_USERNAME: {
    label: "Show Username",
    value: COLUMNS_KEYWORDS.SUBMISSION_USER,
    setting: "column",
    disabled: false
  },
  SHOW_LATEST_MATCH_TIME: {
    label: "Show Latest Match Time",
    value: "show_latest_match_time",
    setting: "column",
    disabled: false
  },
  SHOW_NEW_MATCHES: {
    label: "Show New Matches",
    value: "show_new_matches",
    setting: "column",
    disabled: false
  },
  SHOW_LAST_UPDATED: {
    label: "Show Last Updated",
    value: "show_last_updated",
    setting: "column",
    disabled: false
  },
  SHOW_SOURCE: {
    label: "Show Source",
    value: "show_yara_ruleset_source",
    setting: "column",
    disabled: false
  },
  SHOW_LAST_SEEN: {
    label: "Show Last Seen",
    value: COLUMNS_KEYWORDS.LAST_SEEN,
    setting: "column",
    disabled: false
  },
  SHOW_YARA_RULE: {
    label: "Show Rule",
    value: COLUMNS_KEYWORDS.YARA_RULE,
    setting: "column",
    disabled: false
  },
  INITIAL_SEARCH: {
    setting: "searchResults"
  },
  USE_QUERY_BUILDER: {
    label: (
      <>
        Use Query Builder{" "}
        <span
          style={{ width: "auto" }}
          className="search__grid-actions__preview-label"
        >
          PREVIEW
        </span>
      </>
    ),
    value: "query_builder",
    title: "Use Query Builder",
    setting: "pageSettings",
    disabled: false
  },
  AUTOMATICALLY_EXPAND_SEARCH_PERIOD: {
    label: (
      <div className={"flex align-center flex-gap-1"}>
        Automatically Expand Search Period
        <TooltipIcon
          icon="info-circle"
          message="If there are no results, expand the search period until some results are found."
          placement="bottom"
        />
      </div>
    ),
    value: "automatically_expand_search_period",
    title: "",
    setting: "pageSettings",
    disabled: false
  },
  AUTOMATICALLY_SWITCH_TO_CLOUD: {
    label: "Automatically Switch to Cloud",
    value: "automatically_switch_to_cloud",
    setting: "pageSettings",
    disabled: false
  }
};

export const DEFAULT_MENU_ITEMS: Array<GridItemConfig> = [
  MENU_ITEMS.EXACT_DATE,
  MENU_ITEMS.SHOW_SUBMISSION_TIME,
  MENU_ITEMS.SHOW_USERNAME,
  MENU_ITEMS.INITIAL_SEARCH,
  MENU_ITEMS.USE_QUERY_BUILDER,
  MENU_ITEMS.AUTOMATICALLY_EXPAND_SEARCH_PERIOD,
  MENU_ITEMS.AUTOMATICALLY_SWITCH_TO_CLOUD
];
